import React from 'react';
import { hasCashback, isMultiDiscount } from '../../../../services/partner/utils';
import { DiscountListComponent } from '../../../discount/DiscountListComponent';

import { MetadataMultidiscountsContainer } from './ModalMultiDiscountComponentStyle';

export const ModalMultiDiscountComponent = ({ partner, discounts, REFUND }) => {
    if (isMultiDiscount(partner) && hasCashback(partner) && discounts) {
        return (
            <MetadataMultidiscountsContainer>
                <DiscountListComponent discounts={discounts} />
            </MetadataMultidiscountsContainer>
        );
    }
    return null;
};



// WEBPACK FOOTER //
// ./src/components/pages/interstitiel/metadata/ModalMultiDiscountComponent.js